import { useEffect, useState } from "react";
import {
  DEDUCTION,
  FULL_DEDUCTION,
  NONE_DEDUCTION,
} from "../constants/deduction";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getUserId } from "../reducks/users/selectors";
import { useSelector } from "react-redux";
// 控除判定の計算ロジック本体は純関数としてfunctions/deducationに分離している(Jestのテスト対象)
import {
  calcAfterDeductionPrice,
  getUpdatedDeductionProducts,
} from "../functions/deducation/getUpdatedDeductionProducts";

//全額控除の場合
function getAllDeductionProducts(productsInCart) {
  return productsInCart.map((product) => {
    return {
      ...product,
      deduction_price: calcAfterDeductionPrice(
        Number(product.price) * Number(product.quantity),
        FULL_DEDUCTION
      ), //控除金額
      deduction_id: FULL_DEDUCTION, //控除区分
      deduction_name: DEDUCTION.FULL_DEDUCTION, //控除区分名
      deduction_is_valid: true,
      deduction_correct_count: Number(product.quantity), //控除区分が適用できる数量
    };
  });
}

//控除無しの場合
function getNonDeductionProducts(productsInCart) {
  return productsInCart.map((product) => {
    return {
      ...product,
      deduction_price: calcAfterDeductionPrice(
        Number(product.price) * Number(product.quantity),
        NONE_DEDUCTION
      ), //控除金額
      deduction_id: NONE_DEDUCTION, //控除区分
      deduction_name: DEDUCTION.NONE_DEDUCTION, //控除区分名
      deduction_is_valid: true,
      deduction_correct_count: Number(product.quantity), //控除区分が適用できる数量
    };
  });
}
const getTotalAmountInCart = (productsInCart) => {
  return productsInCart.reduce((sum, product) => {
    return sum + product.quantity;
  }, 0);
};

export const setFireStore = async (updatedProducts, uid) => {
  try {
    // すべての更新処理をPromiseの配列にする
    const updatePromises = updatedProducts.map((product) => {
      const productRef = doc(db, "users", uid, "cart", product.cartId);

      // deductionに関連するフィールドを更新
      return updateDoc(productRef, {
        deduction_price: product.deduction_price,
        deduction_id: product.deduction_id,
        deduction_name: product.deduction_name,
        deduction_is_valid: product.deduction_is_valid,
        deduction_correct_count: product.deduction_correct_count,
      });
    });

    // すべてのPromiseを並列で処理
    await Promise.all(updatePromises);

    console.log("Firestoreにすべてのドキュメントを更新しました！");
  } catch (error) {
    console.error("Firestoreの更新中にエラーが発生しました:", error);
  }
};

export const useCalcDeduction = ({
  categoryCounts,
  categoryMaster,
  productsInCart,
  setProductsInCart,
  orderInfo,
}) => {
  const [isBillingUserOn, setIsBillingUserOn] = useState(false);
  const [isBillingCompanyOn, setIsBillingCompanyOn] = useState(false);
  const [totalCartAmount, setTotalCartAmount] = useState(0);
  const uid = useSelector(getUserId);
  useEffect(() => {
    (async () => {
      if (isBillingUserOn === false && isBillingCompanyOn === false) {
        const updatedProducts = getAllDeductionProducts(productsInCart);
        setProductsInCart(updatedProducts);
        console.log(updatedProducts, "updatedProducts");
        await setFireStore(updatedProducts, uid);
        return;
      }
      if (isBillingUserOn === false && isBillingCompanyOn === true) {
        //仕入先有の場合->控除無し（個人負担=控除金額全額=全額個人（仕入先）負担)
        const updatedProducts = getNonDeductionProducts(productsInCart);
        setProductsInCart(updatedProducts);
        console.log(updatedProducts, "updatedProducts");
        await setFireStore(updatedProducts, uid);
        return;
      }
      //購入依頼者有の場合->判定ロジックに基づいて計算
      if (isBillingUserOn === true && isBillingCompanyOn === false) {
        //仕入先有の場合->控除無し（個人負担=控除金額全額=全額個人（仕入先）負担)
        const updatedProducts = getUpdatedDeductionProducts(
          productsInCart,
          categoryCounts,
          categoryMaster
        );
        setProductsInCart(updatedProducts);
        console.log(updatedProducts, "updatedProducts");
        await setFireStore(updatedProducts, uid);
        return;
      }
      //デフォルト->控除無し（個人負担=控除金額全額=全額個人（仕入先）負担)
      const updatedProducts = getNonDeductionProducts(productsInCart);
      setProductsInCart(updatedProducts);
      console.log(updatedProducts, "updatedProducts");
      //fireStoreに書き込む
      await setFireStore(updatedProducts, uid);
      return;
    })();
    //購入依頼者無・仕入先無の場合->全額控除（個人負担=控除金額0円=全額会社負担)
  }, [
    isBillingCompanyOn,
    isBillingUserOn,
    categoryCounts,
    categoryMaster,
    totalCartAmount,
    setProductsInCart,
    orderInfo,
  ]);

  //フラグの更新
  useEffect(() => {
    setIsBillingUserOn(orderInfo.billing_user_flg === "有" ? true : false);
    setIsBillingCompanyOn(
      orderInfo.billing_company_flg === "有" ? true : false
    );
  }, [orderInfo.billing_user_flg, orderInfo.billing_company_flg]);
  //カート内の数量の合計を取得
  useEffect(() => {
    setTotalCartAmount(getTotalAmountInCart(productsInCart));
  }, [productsInCart]);
  //デバッグ用
  useEffect(() => {
    console.log("DEBUG_BILLING_STATUS", isBillingCompanyOn, isBillingUserOn);
  }, [isBillingCompanyOn, isBillingUserOn]);
};
